import { zAddressDataSchema } from "../zAddressInfo";
import { zBaseCommonSchema } from "./base.common";
/**
 * Base DTO schema - represents data as it comes from the server (flat structure)
 * Contains all scalar address-related fields as separate properties
 */
export const zBaseSchemaDto = zBaseCommonSchema.extend(zAddressDataSchema.shape);
export const zBaseSchemaCreateDto = zBaseSchemaDto.omit({ id: true });
